import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath } from '@xyflow/react'
import EdgeLabel from './EdgeLabel'

function LabeledEdge ({
  id,
  sourceX, sourceY, sourcePosition,
  targetX, targetY, targetPosition,
  data,
  markerEnd,
  style
}) {
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  })

  const label = data?.label

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          stroke: 'var(--color-neutral-300)',
          strokeWidth: 1.5,
          ...style
        }}
      />
      {label && (
        <EdgeLabelRenderer>
          <EdgeLabel
            label={label}
            format={data?.format}
            x={labelX}
            y={labelY}
          />
        </EdgeLabelRenderer>
      )}
    </>
  )
}

LabeledEdge.propTypes = {
  id: PropTypes.string.isRequired,
  sourceX: PropTypes.number.isRequired,
  sourceY: PropTypes.number.isRequired,
  sourcePosition: PropTypes.string.isRequired,
  targetX: PropTypes.number.isRequired,
  targetY: PropTypes.number.isRequired,
  targetPosition: PropTypes.string.isRequired,
  data: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    format: PropTypes.string
  }),
  markerEnd: PropTypes.string,
  style: PropTypes.object
}

export default memo(LabeledEdge)
